/* eslint-disable */
import React from 'react';

/**
 * civil 课程共享内联 SVG 图标集。
 * 每个图标为 () => ReactNode，使用 currentColor，由外层样式控制颜色与尺寸。
 * JSON 中通过字符串 key 引用（如 item.icon = "shield"）。
 */
const svg = (children: React.ReactNode, viewBox = '0 0 24 24') => (
  <svg
    viewBox={viewBox}
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
  >
    {children}
  </svg>
);

export const CIVIL_ICONS: Record<string, () => React.ReactNode> = {
  shield: () => svg(<path d="M12 3l7 3v5.5c0 4.3-2.9 7.4-7 8.9-4.1-1.5-7-4.6-7-8.9V6l7-3z" />),
  lock: () =>
    svg(
      <>
        <rect x="5" y="11" width="14" height="9" rx="2" />
        <path d="M8 11V8a4 4 0 018 0v3" />
      </>
    ),
  key: () =>
    svg(
      <>
        <circle cx="8" cy="15" r="3.2" />
        <path d="M10.4 12.6L19 4M16 7l2.2 2.2M13.6 9.4l2.2 2.2" />
      </>
    ),
  user: () =>
    svg(
      <>
        <circle cx="12" cy="8" r="3.6" />
        <path d="M4.8 20.4c0-3.6 3.2-5.8 7.2-5.8s7.2 2.2 7.2 5.8" />
      </>
    ),
  users: () =>
    svg(
      <>
        <circle cx="9" cy="8" r="3.2" />
        <path d="M2.8 20c0-3.2 2.8-5.2 6.2-5.2s6.2 2 6.2 5.2" />
        <path d="M16.4 5.2a3.2 3.2 0 010 6M18 14.4c2.2.5 3.6 2.2 3.6 4.6" />
      </>
    ),
  file: () =>
    svg(
      <>
        <path d="M6 3h7l5 5v13H6z" />
        <path d="M13 3v5h5" />
      </>
    ),
  folder: () => svg(<path d="M3 7h6l2 2h10v10H3z" />),
  cloud: () => svg(<path d="M7 18a4 4 0 010-8 5 5 0 019.6-1.4A3.4 3.4 0 0117 18H7z" />),
  alert: () =>
    svg(
      <>
        <path d="M12 4l8.5 15H3.5L12 4z" />
        <path d="M12 10v4M12 17h.01" />
      </>
    ),
  check: () => svg(<path d="M4.5 12.5l5 5 10-11" />),
  cross: () => svg(<path d="M6 6l12 12M18 6L6 18" />),
  eye: () =>
    svg(
      <>
        <path d="M2.5 12S6 6.5 12 6.5 21.5 12 21.5 12 18 17.5 12 17.5 2.5 12 2.5 12z" />
        <circle cx="12" cy="12" r="2.8" />
      </>
    ),
  link: () =>
    svg(
      <>
        <path d="M9.5 14.5l5-5" />
        <path d="M11.5 6.8l1.3-1.3a3.6 3.6 0 015.1 5.1l-1.3 1.3" />
        <path d="M12.5 17.2l-1.3 1.3a3.6 3.6 0 01-5.1-5.1l1.3-1.3" />
      </>
    ),
  mail: () =>
    svg(
      <>
        <rect x="3" y="5" width="18" height="14" rx="2" />
        <path d="M3.5 7l8.5 5.5L20.5 7" />
      </>
    ),
  mobile: () =>
    svg(
      <>
        <rect x="7" y="3" width="10" height="18" rx="2" />
        <path d="M11 18h2" />
      </>
    ),
  server: () =>
    svg(
      <>
        <rect x="4" y="4" width="16" height="6" rx="1.4" />
        <rect x="4" y="14" width="16" height="6" rx="1.4" />
        <path d="M7.2 7h.01M7.2 17h.01" />
      </>
    ),
  ai: () =>
    svg(
      <>
        <rect x="7" y="7" width="10" height="10" rx="1.6" />
        <rect x="10.2" y="10.2" width="3.6" height="3.6" rx="0.8" />
        <path d="M9.5 3v2.2M14.5 3v2.2M9.5 18.8V21M14.5 18.8V21M3 9.5h2.2M3 14.5h2.2M18.8 9.5H21M18.8 14.5H21" />
      </>
    ),
  search: () =>
    svg(
      <>
        <circle cx="11" cy="11" r="6" />
        <path d="M20 20l-4.2-4.2" />
      </>
    ),
  refresh: () =>
    svg(
      <>
        <path d="M20 11.5a8 8 0 10-1.6 5.6" />
        <path d="M20 20v-4.5h-4.5" />
      </>
    ),
  report: () =>
    svg(
      <>
        <path d="M6 3h7l5 5v13H6z" />
        <path d="M13 3v5h5" />
        <path d="M9 14.5l2 2 4-4" />
      </>
    ),
  database: () =>
    svg(
      <>
        <ellipse cx="12" cy="6" rx="7" ry="2.8" />
        <path d="M5 6v12c0 1.6 3.1 2.8 7 2.8s7-1.2 7-2.8V6" />
        <path d="M5 12c0 1.6 3.1 2.8 7 2.8s7-1.2 7-2.8" />
      </>
    ),
  network: () =>
    svg(
      <>
        <circle cx="12" cy="5" r="2.2" />
        <circle cx="5" cy="18" r="2.2" />
        <circle cx="19" cy="18" r="2.2" />
        <path d="M10.6 7l-4 8.6M13.4 7l4 8.6M7.2 18h9.6" />
      </>
    ),
  stop: () =>
    svg(
      <>
        <circle cx="12" cy="12" r="8.5" />
        <path d="M9 9l6 6M15 9l-6 6" />
      </>
    ),
  tools: () =>
    svg(
      <>
        <path d="M14.5 6.5a3.5 3.5 0 104.9 4.9l1.6-1.6a3.5 3.5 0 01-4.9-4.9l-1.6 1.6z" />
        <path d="M13 8L4.8 16.2a2 2 0 002.8 2.8L16 10.6" />
      </>
    ),
  governance: () =>
    svg(
      <>
        <rect x="12" y="68" width="43" height="7" rx="3.5" fill="#77C2FF" />
        <path
          d="M11.3333 31.1666C18.0964 31.1666 24.5824 33.8532 29.3646 38.6354C34.1467 43.4175 36.8333 49.9036 36.8333 56.6666M11.3333 11.3333C23.3565 11.3333 34.8872 16.1094 43.3888 24.6111C51.8905 33.1127 56.6667 44.6434 56.6667 56.6666M17 53.8333C17 55.3981 15.7315 56.6666 14.1667 56.6666C12.6019 56.6666 11.3333 55.3981 11.3333 53.8333C11.3333 52.2684 12.6019 50.9999 14.1667 50.9999C15.7315 50.9999 17 52.2684 17 53.8333Z"
          stroke="#1E1E1E"
          strokeWidth={3}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </>,
      '0 0 68 75'
    ),
  aiTech: () =>
    svg(
      <>
        <path
          d="M36 45C40.9706 45 45 40.9706 45 36C45 31.0294 40.9706 27 36 27C31.0294 27 27 31.0294 27 36C27 40.9706 31.0294 45 36 45Z"
          stroke="#1E1E1E" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        <path
          d="M58.2 45C57.8007 45.9048 57.6815 46.9086 57.858 47.8818C58.0344 48.855 58.4984 49.753 59.19 50.46L59.37 50.64C59.9279 51.1972 60.3704 51.859 60.6724 52.5874C60.9743 53.3157 61.1297 54.0965 61.1297 54.885C61.1297 55.6735 60.9743 56.4543 60.6724 57.1826C60.3704 57.911 59.9279 58.5728 59.37 59.13C58.8128 59.6879 58.151 60.1304 57.4226 60.4324C56.6943 60.7343 55.9135 60.8897 55.125 60.8897C54.3365 60.8897 53.5557 60.7343 52.8274 60.4324C52.099 60.1304 51.4372 59.6879 50.88 59.13L50.7 58.95C49.993 58.2584 49.095 57.7944 48.1218 57.618C47.1486 57.4415 46.1448 57.5607 45.24 57.96C44.3527 58.3403 43.5959 58.9717 43.0629 59.7766C42.5299 60.5815 42.2438 61.5246 42.24 62.49V63C42.24 64.5913 41.6079 66.1174 40.4826 67.2426C39.3574 68.3679 37.8313 69 36.24 69C34.6487 69 33.1226 68.3679 31.9974 67.2426C30.8721 66.1174 30.24 64.5913 30.24 63V62.73C30.2168 61.737 29.8954 60.774 29.3175 59.9661C28.7397 59.1582 27.9322 58.5429 27 58.2C26.0952 57.8007 25.0914 57.6815 24.1182 57.858C23.145 58.0344 22.247 58.4984 21.54 59.19L21.36 59.37C20.8028 59.9279 20.141 60.3704 19.4126 60.6724C18.6843 60.9743 17.9035 61.1297 17.115 61.1297C16.3265 61.1297 15.5457 60.9743 14.8174 60.6724C14.089 60.3704 13.4272 59.9279 12.87 59.37C12.3121 58.8128 11.8696 58.151 11.5676 57.4226C11.2657 56.6943 11.1103 55.9135 11.1103 55.125C11.1103 54.3365 11.2657 53.5557 11.5676 52.8274C11.8696 52.099 12.3121 51.4372 12.87 50.88L13.05 50.7C13.7416 49.993 14.2056 49.095 14.382 48.1218C14.5585 47.1486 14.4393 46.1448 14.04 45.24C13.6597 44.3527 13.0283 43.5959 12.2234 43.0629C11.4185 42.5299 10.4754 42.2438 9.51 42.24H9C7.4087 42.24 5.88258 41.6079 4.75736 40.4826C3.63214 39.3574 3 37.8313 3 36.24C3 34.6487 3.63214 33.1226 4.75736 31.9974C5.88258 30.8721 7.4087 30.24 9 30.24H9.27C10.263 30.2168 11.226 29.8954 12.0339 29.3175C12.8418 28.7397 13.4571 27.9322 13.8 27C14.1993 26.0952 14.3185 25.0914 14.142 24.1182C13.9656 23.145 13.5016 22.247 12.81 21.54L12.63 21.36C12.0721 20.8028 11.6296 20.141 11.3276 19.4126C11.0257 18.6843 10.8703 17.9035 10.8703 17.115C10.8703 16.3265 11.0257 15.5457 11.3276 14.8174C11.6296 14.089 12.0721 13.4272 12.63 12.87C13.1872 12.3121 13.849 11.8696 14.5774 11.5676C15.3057 11.2657 16.0865 11.1103 16.875 11.1103C17.6635 11.1103 18.4443 11.2657 19.1726 11.5676C19.901 11.8696 20.5628 12.3121 21.12 12.87L21.3 13.05C22.007 13.7416 22.905 14.2056 23.8782 14.382C24.8514 14.5585 25.8552 14.4393 26.76 14.04H27C27.8873 13.6597 28.6441 13.0283 29.1771 12.2234C29.7101 11.4185 29.9961 10.4754 30 9.51V9C30 7.4087 30.6321 5.88258 31.7574 4.75736C32.8826 3.63214 34.4087 3 36 3C37.5913 3 39.1174 3.63214 40.2426 4.75736C41.3679 5.88258 42 7.4087 42 9V9.27C42.0039 10.2354 42.2899 11.1785 42.8229 11.9834C43.3559 12.7883 44.1127 13.4197 45 13.8C45.9048 14.1993 46.9086 14.3185 47.8818 14.142C48.855 13.9656 49.753 13.5016 50.46 12.81L50.64 12.63C51.1972 12.0721 51.859 11.6296 52.5874 11.3276C53.3157 11.0257 54.0965 10.8703 54.885 10.8703C55.6735 10.8703 56.4543 11.0257 57.1826 11.3276C57.911 11.6296 58.5728 12.0721 59.13 12.63C59.6879 13.1872 60.1304 13.849 60.4324 14.5774C60.7343 15.3057 60.8897 16.0865 60.8897 16.875C60.8897 17.6635 60.7343 18.4443 60.4324 19.1726C60.1304 19.901 59.6879 20.5628 59.13 21.12L58.95 21.3C58.2584 22.007 57.7944 22.905 57.618 23.8782C57.4415 24.8514 57.5607 25.8552 57.96 26.76V27C58.3403 27.8873 58.9717 28.6441 59.7766 29.1771C60.5815 29.7101 61.5246 29.9961 62.49 30H63C64.5913 30 66.1174 30.6321 67.2426 31.7574C68.3679 32.8826 69 34.4087 69 36C69 37.5913 68.3679 39.1174 67.2426 40.2426C66.1174 41.3679 64.5913 42 63 42H62.73C61.7646 42.0039 60.8215 42.2899 60.0166 42.8229C59.2117 43.3559 58.5803 44.1127 58.2 45Z"
          stroke="#1E1E1E" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
      </>,
      '0 0 72 72'
    ),
  aiGovernance: () =>
    svg(
      <>
        <path d="M22.5 34.5H40.5M61.5 49.5C61.5 51.0913 60.8679 52.6174 59.7426 53.7426C58.6174 54.8679 57.0913 55.5 55.5 55.5H7.5C5.9087 55.5 4.38258 54.8679 3.25736 53.7426C2.13214 52.6174 1.5 51.0913 1.5 49.5V7.5C1.5 5.9087 2.13214 4.38258 3.25736 3.25736C4.38258 2.13214 5.9087 1.5 7.5 1.5H22.5L28.5 10.5H55.5C57.0913 10.5 58.6174 11.1321 59.7426 12.2574C60.8679 13.3826 61.5 14.9087 61.5 16.5V49.5Z" stroke="#1E1E1E" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
      </>,
      '0 0 72 72'
    ),
  aiGuidance: () =>
    svg(
      <>
        <path d="M57 15V57M15 12L45 36L15 60V12Z" stroke="#1E1E1E" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
      </>,
      '0 0 72 72'
    ),
  aiGoal: () =>
    svg(
      <>
        <path d="M36 6L45.27 24.78L66 27.81L51 42.42L54.54 63.06L36 53.31L17.46 63.06L21 42.42L6 27.81L26.73 24.78L36 6Z" stroke="#1E1E1E" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
      </>,
      '0 0 72 72'
    ),
  browser: () =>
    svg(
      <>
        <rect x="3" y="4" width="18" height="16" rx="2" />
        <path d="M3 9h18M6.2 6.5h.01M9 6.5h.01" />
      </>
    ),
  download: () =>
    svg(
      <>
        <path d="M12 4v10M8.2 10.5L12 14.3l3.8-3.8" />
        <path d="M5 19h14" />
      </>
    ),
  share: () =>
    svg(
      <>
        <circle cx="6" cy="12" r="2.4" />
        <circle cx="17.5" cy="6" r="2.4" />
        <circle cx="17.5" cy="18" r="2.4" />
        <path d="M8.2 10.9l7.2-3.8M8.2 13.1l7.2 3.8" />
      </>
    ),
  password: () =>
    svg(
      <>
        <rect x="4" y="10" width="16" height="10" rx="2" />
        <path d="M8 10V7a4 4 0 018 0v3M12 14v2.5" />
      </>
    ),
};

export const getCivilIcon = (key?: string): React.ReactNode => {
  if (!key) return undefined;
  const render = CIVIL_ICONS[key];
  return render ? render() : undefined;
};

export default CIVIL_ICONS;
